import { render, staticRenderFns } from "./CKeditorComponents.vue?vue&type=template&id=3c5fc17a&"
import script from "./CKeditorComponents.vue?vue&type=script&lang=js&"
export * from "./CKeditorComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports